import { ThemeProvider } from '@emotion/react';
import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import ReactDOM from 'react-dom/client';
import { Helmet } from 'react-helmet';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import App from './App';
import Absences from './components/absences';
import { URLS } from './components/common/constants';
import { useBranding } from './components/common/hooks/useBranding';
import Dashboard from './components/dashboard';
import UserGroups from './components/groups';
import Invitations from './components/invitations';
import MyProfile from './components/profile';
import Team from './components/team';
import Workflows from './components/customers';
import ViewWorkflow from './components/customers/ViewWorkflow';
import WorkSpace from './components/workspace';
import './index.css';
import Customers from './components/customers';
import ErrorPage from './components/error';
import Reports from './components/reports';
import StartApp from './App';
import RegisterPage from './components/register';
import { useEffect } from 'react';
import CustomerApprovalPage from 'components/customerApproval';
// import App from './App';

// Initialize Firebase
// const firebaseConfig = {
// 	apiKey: "AIzaSyBz4iSF_Ujw3dighO2ceq2QouKWvb-VWRU",
// 	authDomain: "rotapadv3-b3a1c.firebaseapp.com",
// 	projectId: "rotapadv3-b3a1c",
// 	// storageBucket: "rotapadv3-b3a1c.appspot.com",
// 	messagingSenderId: "329387562735",
// 	appId: "1:329387562735:web:c9da7636406df98c036d1a",
// 	measurementId: "G-NQPS1V9TS4",
// 	databaseURL: "https://rotapadv3-b3a1c-default-rtdb.firebaseio.com/",
// 	storageBucket: "gs://rotapadv3-b3a1c.appspot.com",
// };

// const firebaseConfig = {
//   apiKey: 'AIzaSyDZJa6JVm_YfbkuMW_lI0S4rdcJUpqURaE',
//   authDomain: 'xynexcare-69d09.firebaseapp.com',
//   databaseURL: 'https://xynexcare-69d09-default-rtdb.firebaseio.com/',
//   projectId: 'xynexcare-69d09',
//   storageBucket: 'gs://xynexcare-69d09.appspot.com',
//   messagingSenderId: '241151709958',
//   appId: '1:241151709958:web:c9d3b6ea816d857a474487',
//   measurementId: 'G-0GWSH2GGJJ',
// };

console.log('REACT_APP_MOCK ===== ', process.env.REACT_APP_MOCK);
const firebaseConfig = {
  apiKey: 'AIzaSyDQIojW0twtj9VtliRPkBVHhD0uD_AMr0k',
  authDomain: 'beta-ed830.firebaseapp.com',
  databaseURL: 'https://beta-ed830-default-rtdb.firebaseio.com/',
  projectId: 'beta-ed830',
  storageBucket: 'gs://beta-ed830.appspot.com',
  messagingSenderId: '515953610329',
  appId: '1:515953610329:web:7ba1a26197337787fcab48',
  measurementId: 'G-LYGMR67N8D',
};

const app = initializeApp(firebaseConfig);
// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);
const analytics = getAnalytics(app);
// Initialize Realtime Database and get a reference to the service
const database = getDatabase(app);
// Initialize Cloud Storage and get a reference to the service
const storage = getStorage(app);

const RotaPadApp = ({
  thisapp,
  thisanalytics,
  thisauth,
  thisdatabase,
  thisstorage,
}: {
  thisapp: any;
  thisanalytics: any;
  thisauth: any;
  thisdatabase: any;
  thisstorage: any;
}) => {
  const { colour, title } = useBranding();

  return (
    <>
      <ThemeProvider theme={colour}>
        <StartApp
          app={thisapp}
          analytics={thisanalytics}
          auth={thisauth}
          database={thisdatabase}
          storage={thisstorage}
        />
        <ToastContainer />
      </ThemeProvider>
    </>
  );
};
// RegisterPage
const ErrorPageContainer = () => {
  const { colour, title } = useBranding();
  // let urlParams = useParams();

  return (
    <>
      <ThemeProvider theme={colour}>
        <ErrorPage />
      </ThemeProvider>
    </>
  );
};

const RegisterPageContainer = () => {
  const { colour, title } = useBranding();

  return (
    <>
      <ThemeProvider theme={colour}>
        <RegisterPage
          app={app}
          analytics={analytics}
          auth={auth}
          database={database}
          storage={storage}
        />
      </ThemeProvider>
    </>
  );
};

const CustomerApprovalPageContainer = () => {
  const { colour, title } = useBranding();

  return (
    <>
      <ThemeProvider theme={colour}>
        <CustomerApprovalPage
          app={app}
          analytics={analytics}
          auth={auth}
          database={database}
          storage={storage}
        />
      </ThemeProvider>
    </>
  );
};

const router = createBrowserRouter([
  {
    path: URLS.approve,
    element: (
      <>
        <CustomerApprovalPageContainer />
      </>
    ),
    errorElement: (
      <>
        <ErrorPageContainer />
      </>
    ),
  },

  {
    path: URLS.onboard,
    element: (
      <>
        <RegisterPageContainer />
      </>
    ),
    errorElement: (
      <>
        <ErrorPageContainer />
      </>
    ),
  },
  {
    path: '/',
    element: (
      <>
        <RotaPadApp
          thisapp={app}
          thisanalytics={analytics}
          thisauth={auth}
          thisdatabase={database}
          thisstorage={storage}
        />
      </>
    ),
    errorElement: (
      <>
        <ErrorPageContainer />
      </>
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate
            to={URLS.dashboard}
            replace={true}
          />
        ),
      },
      // {
      //   // The idea to give the illusion if segements but in actuality we only have segements of months and reports
      //   // months + reports are non global
      //   //multiple instances idea - workspace per insta
      //   path: '/workspace/:Id' + URLS.months,
      //   element: <WorkSpace />,
      // },
      {
        //multiple instances idea - reports per insta
        path: URLS.reports,
        element: <Reports />,
      },
      // {
      //   path: '/workspace/:Id' + URLS.team,
      //   element: <p>workspace team (group members)</p>,
      // },
      {
        path: URLS.absences,
        element: <Absences />,
      },
      {
        path: URLS.team,
        element: <Team />,
      },
      {
        path: URLS.profile,
        element: <MyProfile />,
      },
      {
        path: URLS.groups,
        element: <UserGroups />,
      },
      {
        path: URLS.invitations,
        element: <Invitations />,
      },
      {
        path: URLS.dashboard,
        element: <Dashboard />,
      },
      {
        path: URLS.customers,
        element: <Customers />,
      },
    ],
  },
]);

// ReactDOM.render(
// 	<RouterProvider router={router} />,
// 	document.getElementById("root") as HTMLElement
// );

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<RouterProvider router={router} />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
